




























































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";

import BirthdayStaffAvailableJson from "../../shared/BirthdayStaffAvailableJson";
import UserJson from "../../shared/UserJson";

import { BirthdayStaffAvailableStatus } from "../../shared/BirthdayStaffAvailableStatus";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "BirthdaysStaffBirthdays",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      allUsers: null as UserJson[] | null,
      selectedUserId: null as number | null,
      staffAvailable: null as BirthdayStaffAvailableJson[] | null,
      useFilters: false as boolean,
      filterStaffId: null as number | null,
      BirthdayStaffAvailableStatus: {
        open: "Frei zur Buchung",
        reserved: "Reserviert",
        booked: "Gebucht",
      },
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    loadData() {
      this.loadAllUsers();
      this.loadStaffAvailable();
    },

    async loadAllUsers() {
      this.allUsers = null;
      if (this.restClient != null) {
        try {
          this.allUsers = await this.restClient.getUsers();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadStaffAvailable() {
      this.staffAvailable = null;
      try {
        this.staffAvailable = await this.restClient.getBirthdayStaffAvailability(this.filterStaffId);
      } catch (e) {
        alert(e.message);
      }
    },

    getStaffFullName(staffId: number | null) {
      if (staffId != null) {
        if (this.allUsers != null) {
          let staff = this.allUsers.find((user) => user.ID == staffId);

          return staff?.firstName + " " + staff?.lastName;
        }
      } else {
        return "--";
      }
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadStaffAvailable();
    },

    removeUseFilters() {
      this.useFilters = false;
      this.filterStaffId = null;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadStaffAvailable();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    staffAvailableColumns: function (): TableViewColumnDefinitions<BirthdayStaffAvailableJson>[] {
      let vue = this;

      return [
        {
          th: "Name",
          td: (i) => vue.getStaffFullName(i.staffId),
        },
        {
          th: "Datum",
          td: (i) => DateFormatter.formatDateWeekday(new Date(i.beginDateTime)),
          sortBy: (i) => i.beginDateTime,
        },
        {
          th: "Uhrzeit",
          td: (i) =>
            DateFormatter.formatTime(new Date(i.beginDateTime)) +
            " – " +
            DateFormatter.formatTime(new Date(i.endDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.BirthdayStaffAvailableStatus[i.status],
        },
      ] as TableViewColumnDefinitions<BirthdayStaffAvailableJson>[];
    },

    upcomingStaffAvailable(): BirthdayStaffAvailableJson[] | null | undefined {
      if (this.staffAvailable != null) {
        var today = new Date().setHours(0, 0, 0, 0);
        var upcomingStaffAvailable = this.staffAvailable.filter(
          (i) => new Date(i.beginDateTime).setHours(0, 0, 0, 0) > today
        );
        return upcomingStaffAvailable;
      }
    },
  },
});
